import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    byOrganizationId: {},
    recommendationsByOrganizationId: {},
    changeEvents: []
};

const companyStrategySlice = createSlice({
    name: 'companyStrategy',
    initialState,
    reducers: {
        setCompanyStrategy: (state, action) => {
            const { organizationId, strategyId, selectedByUser = false, reason = null } = action.payload || {};
            if (!organizationId || !strategyId) return;

            state.byOrganizationId[organizationId] = {
                strategyId,
                selectedByUser,
                reason,
                updatedAt: new Date().toISOString()
            };
        },
        setCompanyRecommendation: (state, action) => {
            const { organizationId, strategyId, confidence = 0, reason = '' } = action.payload || {};
            if (!organizationId || !strategyId) return;

            state.recommendationsByOrganizationId[organizationId] = {
                strategyId,
                confidence,
                reason,
                updatedAt: new Date().toISOString()
            };
        },
        dismissCompanyRecommendation: (state, action) => {
            const { organizationId } = action.payload || {};
            if (!organizationId) return;

            delete state.recommendationsByOrganizationId[organizationId];
        },
        pushStrategyChangeEvent: (state, action) => {
            const event = action.payload;
            if (!event?.organizationId || !event?.type) return;

            state.changeEvents.unshift({
                ...event,
                id: `${event.organizationId}-${event.type}-${Date.now()}`,
                createdAt: new Date().toISOString()
            });
            state.changeEvents = state.changeEvents.slice(0, 50);
        },
        clearStrategyChangeEvent: (state, action) => {
            state.changeEvents = state.changeEvents.filter((event) => event.id !== action.payload);
        }
    }
});

export const {
    setCompanyStrategy,
    setCompanyRecommendation,
    dismissCompanyRecommendation,
    pushStrategyChangeEvent,
    clearStrategyChangeEvent
} = companyStrategySlice.actions;

export default companyStrategySlice.reducer;
